'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { usePathname } from 'next/navigation';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { TopNavV5Tile } from '@src/components/TopNavV5/TopNavV5Tile';
import { getUnlocalizedPath } from '@src/i18n/locale.util';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavV5DesktopSubMenu = () => {
  const $ = _c(37);
  const pathname = usePathname();
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    setExpanded,
    expandedMenu,
    leftMenuIndex
  } = useTopNavV5();
  const subMenu = expandedMenu?.subMenu ?? expandedMenu?.leftMenuItems?.[leftMenuIndex];
  let t0;
  if ($[0] !== pathname) {
    t0 = function isCurrentPage(t1) {
      const href = t1 === undefined ? "/" : t1;
      ;
      try {
        const linkUrl = new URL(href, window.location.origin);
        return linkUrl.pathname === getUnlocalizedPath(pathname);
      } catch (t2) {
        return false;
      }
    };
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCurrentPage = t0;
  let t1;
  if ($[2] !== isCurrentPage || $[3] !== setExpanded || $[4] !== subMenu?.items || $[5] !== trackSelectNavCta) {
    t1 = () => subMenu?.items?.filter(_temp).map((subItem_0, index) => <div key={index}><div className="mb-2 w-fit text-body-md font-medium">{subItem_0.isLink ? <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": subItem_0?.link?.href ?? ""
          });
          if (isCurrentPage(subItem_0.link?.href ?? "")) {
            setExpanded(false);
          }
        }} className="inline-block hover:underline" href={subItem_0.link?.href ?? ""} rel={subItem_0.link?.newTab ? "noopener noreferrer" : ""} target={subItem_0.link?.newTab ? "_blank" : "_self"}>{subItem_0.title}</LocalizedLink> : <div>{subItem_0.title}</div>}</div><div className="flex flex-col gap-1">{subItem_0.links?.filter(_temp2).map(link_0 => <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": link_0?.href
          });
          if (isCurrentPage(link_0.href)) {
            setExpanded(false);
          }
        }} className="flex w-fit items-center gap-1 rounded-md font-medium text-bodi-gray-butters transition-all hover:text-bodi-white hover:underline" key={`${link_0.title}-${index}`} href={link_0.href ?? ""} rel={link_0.newTab ? "noopener noreferrer" : ""} target={link_0.newTab ? "_blank" : "_self"}>{link_0.title}{link_0.stamp && <>{" - "}<span className="text-body-sm font-medium text-bodi-accent-bright-500">{link_0.stamp}</span></>}</LocalizedLink>)}</div></div>);
    $[2] = isCurrentPage;
    $[3] = setExpanded;
    $[4] = subMenu?.items;
    $[5] = trackSelectNavCta;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const renderSubItems = t1;
  let t2;
  if ($[7] !== subMenu?.tiles) {
    t2 = () => {
      const tiles = (subMenu?.tiles ?? []).filter(_temp3);
      if (tiles.length < 1) {
        return null;
      }
      return tiles?.map(_temp4);
    };
    $[7] = subMenu?.tiles;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const renderTiles = t2;
  const numItems = subMenu?.items?.length ?? 0;
  const numTiles = subMenu?.tiles?.length ?? 0;
  let t3;
  if ($[9] !== subMenu?.ctaDesktop?.href || $[10] !== subMenu?.ctaDesktop?.newTab || $[11] !== subMenu?.ctaDesktop?.title || $[12] !== trackSelectNavCta) {
    t3 = subMenu?.ctaDesktop?.title && <div className="text-heading-display-3 mb-6 inline-flex items-center gap-2">{subMenu?.ctaDesktop?.href ? <LocalizedLink className="hover:underline" href={subMenu?.ctaDesktop?.href ?? ""} rel={subMenu?.ctaDesktop?.newTab ? "noopener noreferrer" : ""} target={subMenu?.ctaDesktop?.newTab ? "_blank" : "_self"} onClick={() => {
        trackSelectNavCta({
          "cta url": subMenu?.ctaDesktop?.href
        });
      }}>{subMenu?.ctaDesktop?.title}</LocalizedLink> : <div>{subMenu?.ctaDesktop?.title}</div>}<ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></div>;
    $[9] = subMenu?.ctaDesktop?.href;
    $[10] = subMenu?.ctaDesktop?.newTab;
    $[11] = subMenu?.ctaDesktop?.title;
    $[12] = trackSelectNavCta;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const t4 = numTiles === 2 && numItems > 4 || numTiles < 2;
  const t5 = numTiles === 2 && numItems <= 4;
  const t6 = numTiles === 0;
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = cn("grid grid-cols-subgrid gap-8", {
      "col-span-3": t4,
      "col-span-2": t5,
      "col-span-4": t6
    });
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== renderSubItems) {
    t8 = renderSubItems();
    $[18] = renderSubItems;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = numTiles === 2 && numItems <= 4;
  const t11 = numTiles === 0;
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = cn("grid grid-cols-subgrid gap-8", {
      "col-span-2": t10,
      hidden: t11
    });
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== renderTiles) {
    t13 = renderTiles();
    $[26] = renderTiles;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t9) {
    t15 = <div className="grid w-full grid-cols-4 gap-10">{t9}{t14}</div>;
    $[31] = t14;
    $[32] = t9;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15 || $[35] !== t3) {
    t16 = <>{t3}{t15}</>;
    $[34] = t15;
    $[35] = t3;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
function _temp(subItem) {
  return Boolean(subItem.title);
}
function _temp2(link) {
  return Boolean(link.title);
}
function _temp3(tile) {
  return tile.isVisible ?? true;
}
function _temp4(tile_0, i) {
  return <TopNavV5Tile tile={tile_0} key={i} />;
}